/**
 * Commentary feedback API client — POSTs a user report to the inbox.
 */

import type { CommentaryFeedback } from '@skjv/common';
import { apiPath } from '@utils/api-base';

export async function submitCommentaryFeedback(feedback: CommentaryFeedback): Promise<void> {
  const response = await fetch(apiPath('v1/commentary-feedback'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(feedback),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new Error(body?.error ?? `Feedback submit failed: ${response.status}`);
  }
}
